import { useEffect, useLayoutEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import resumeMarkdown from "../../../src/content/other/resume.mdx?raw";
import "./Resume.css";

const RESUME_PDF = "/resume-combined.pdf";

export default function ResumePage() {
	useLayoutEffect(() => {
		window.scrollTo({ top: 0, behavior: "instant" });
	}, []);

	useEffect(() => {
		const previousTitle = document.title;
		document.title = "Resume · CQBLOG JOURNAL";
		return () => { document.title = previousTitle; };
	}, []);

	return <main className="resume-page">
		<header className="resume-hero">
			<div>
				<p className="resume-kicker">04 / RESUME</p>
				<h1>履历</h1>
			</div>
			<div className="resume-hero-intro">
				<p>面向招聘与合作的完整职业履历，记录后端架构、物联网、实时计算与音视频方向的工作经验。</p>
				<nav className="resume-actions" aria-label="简历操作">
					<a className="resume-action-primary" href={RESUME_PDF} download>下载完整 PDF <span aria-hidden="true">↓</span></a>
					<a href="mailto:cqmike0315@gmail.com">Email <span aria-hidden="true">↗</span></a>
					<a href="tel:+8613308423786">Phone <span aria-hidden="true">↗</span></a>
					<a href="https://github.com/chenqi146" target="_blank" rel="noreferrer">GitHub <span aria-hidden="true">↗</span></a>
				</nav>
			</div>
		</header>
		<article className="resume-document" aria-label="陈琪的职业履历">
			<ReactMarkdown remarkPlugins={[remarkGfm]}>{resumeMarkdown}</ReactMarkdown>
		</article>
		<footer className="resume-footer"><a href={RESUME_PDF} download>下载完整 PDF ↓</a><span>OPEN TO RECRUITING &amp; COLLABORATION</span></footer>
	</main>;
}
